// @flow
import React, { type Node } from 'react';
import classNames from 'classnames';

import PlainButton from 'app/common/ui-next/plain-button';
import PlainLinkAsButton from 'app/common/ui-next/plain-link-as-button';

import styles from './CheckoutButton.module.scss';;


type Props = {
  children: Node,
  onClick?: (e: SyntheticEvent<HTMLElement>) => void | Promise<void>,
  disabled?: boolean,
  to?: string,
  outline?: boolean,
  // component?: ElementType,
  className?: string,
  ariaLabel?: string,
}

const CheckoutButton = ({
  children,
  onClick,
  disabled,
  to = '',
  outline,
  className,
  ariaLabel,
  // component,
}: Props) => {
  const props = {
    className: classNames(styles.root, className),
    disabled,
    outline,
    ariaLabel,
  };

  if (onClick) {
    return (
      <PlainButton {...props} onClick={onClick}>
        {children}
      </PlainButton>
    );
  }

  return (
    <PlainLinkAsButton {...props} to={to}>
      {children}
    </PlainLinkAsButton>
  );
};

export default CheckoutButton;
